export default function Error404() { return <h1>Error 404: Page not found.</h1> }